export default {
  1: "Aumento de valor",
  2: "Aumento de prazo",
  3: "Aumento de valor e prazo",
  4: "Redução de valor",
  5: "Redução de prazo",
  6: "Correção de dados",
  7: "Endosso de cancelamento",
};
